import React, { useEffect, useState } from "react";
import {
  CreditCard,
  Calendar,
  Download,
  AlertCircle,
  ChevronRight,
  RefreshCw,
  HelpCircle,
  Bell,
} from "lucide-react";
import { useAuth } from "../../../AuthProvider";
import { Header } from '../../Header'
import { getBillingData, getBillingPortalLink } from "../../../api/apiClient";

export const Billing = () => {

  const { currentUser } = useAuth();
  const [billingData, setBillingData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [portalLoading, setPortalLoading] = useState(false);

  const fetchBillingData = async () => {
    try {
      if (!currentUser) return;

      const headers = {
        Authorization: `Bearer ${await currentUser.getIdToken()}`,
        "X-User-Id": currentUser.uid,
      };

      const response = await getBillingData(headers);

      setBillingData(response.data.data);
      setLoading(false);
    } catch (err) {
      console.error("Error fetching billing data:", err);
      setError("Failed to load billing information");
      setLoading(false);
    }
  };

  // const cancelPlan = async () => {
  //   try {
  //     if (!currentUser) return;

  //     const headers = {
  //       Authorization: `Bearer ${await currentUser.getIdToken()}`,
  //       "X-User-Id": currentUser.uid,
  //     };

  //     setLoading(true);
  //     const response = await cancelBillingPlan(headers);

  //     // Refresh billing data after cancellation
  //     await fetchBillingData();
  //   } catch (err) {
  //     console.error("Error cancelling plan:", err);
  //     setError("Failed to cancel plan");
  //     setLoading(false);
  //   }
  // };

  const handleBillingPortal = async () => {
    try {
      setPortalLoading(true);
      if (!currentUser) return;

      const authToken = await currentUser.getIdToken();
      const headers = {
        Authorization: `Bearer ${authToken}`,
        "X-User-Id": currentUser.uid,
      };

      const response = await getBillingPortalLink(headers);

      if (response.data && response.data.url) {
        window.location.href = response.data.url;
      } else {
        console.error('No portal URL received');
        setPortalLoading(false);
      }
    } catch (error) {
      console.error('Error accessing billing portal:', error);
      setPortalLoading(false);
    }
  };  

  useEffect(() => {
    fetchBillingData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentUser]);

  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", { 
      year: 'numeric', 
      month: 'short', 
      day: 'numeric' 
    });
  };

  const getPlanDetails = (planName) => {
    const plans = {
      "free": {
        name: "Free Plan",
        color: "bg-gray-100 text-gray-800",
        limits: "10"
      },
      "starter": {
        name: "Starter Plan",
        color: "bg-blue-100 text-blue-800",
        limits: "50 /month"
      },
      "pro": {
        name: "Pro Plan",
        color: "bg-violet-100 text-violet-800",
        limits: "200 /month"
      },
      "growth": {
        name: "Growth Plan",
        color: "bg-violet-100 text-violet-800",
        limits: "500 /month"
      }      
    };
    
    return plans[planName] || {
      name: planName.charAt(0).toUpperCase() + planName.slice(1),
      color: "bg-gray-100 text-gray-800",
      limits: "Custom"
    };
  };

  return (
    <>
    <Header title={"Billing and Plans"}/>
    <div className="flex flex-row justify-start items-center w-full bg-slate-50">
      {/* Main Content */}
      <div className="flex flex-col justify-start items-center mt-10 md:mt-3 w-full lg:flex-1">
        {/* Content Area */}
        <div className="flex flex-row justify-start items-start w-full py-3 px-3 lg:py-6 lg:px-6 -mt-0.5">
          <div className="flex flex-col lg:flex-row gap-3 lg:gap-6 justify-start items-start w-full mb-10 lg:mb-20">            
            {/* Left Column */}
            {/* <div className="flex flex-col gap-3 lg:gap-6 justify-start items-center w-full lg:w-1/3">              
               {/* Plans Overview }
               <div className="flex flex-col gap-2 lg:gap-4 justify-start items-center w-full shadow-sm border border-gray-200 rounded-xl py-2 px-2 lg:py-4 lg:px-4 bg-white">
                <div className="flex flex-row justify-start items-center w-full mt-1 lg:mt-1.5">
                  <span className="text-base lg:text-lg font-semibold leading-5 lg:leading-6 text-left text-black">Available Plan</span>
                </div>
                 <div className="flex flex-col gap-1.5 lg:gap-3 justify-start items-center w-full"> */}
                   {/* {["free", "starter","pro", "growth"].map((plan) => {
                     const planDetails = getPlanDetails(plan);
                     const isCurrentPlan = billingData?.current_plan?.plan === plan;
                     
                     return (
                       <div 
                         key={plan}
                         className={`flex flex-row justify-start items-center w-full border rounded-xl py-2 px-2 lg:py-4 lg:px-4 ${isCurrentPlan ? 'border-gray-200 bg-purple-50' : 'border-gray-200 hover:border-violet-300'}`}
                       >
                         <div className="flex justify-between items-center">
                           <div className="flex items-center">
                             <span className={`text-xs font-medium px-2 py-1 rounded ${planDetails.color}`}>
                               {planDetails.name}
                             </span>
                             <span className="text-sm lg:text-base font-normal leading-5 lg:leading-5 text-left text-gray-500 ml-1 lg:ml-2">
                               {planDetails.limits}
                             </span>
                           </div>
                           {isCurrentPlan ? (
                             <span className="text-sm font-medium leading-4 text-center text-purple-600 border border-blue-200 rounded-xl py-0.5 px-2.5 bg-white">
                               Current Plan
                             </span>
                           ) : (
                             <ChevronRight size={16} className="text-gray-400" />
                           )}
                         </div>
                       </div>
                     );
                   })}
                 </div>
                 <div className="flex flex-row justify-start items-start w-full mb-4">
                   <p className="text-sm text-gray-600 italic">
                     Limits are for the number of images you can generate or process
                   </p>
                 </div>
                 <div className="flex flex-row justify-start items-start w-full">
                   <a 
                     href="/pricing" 
                     className="text-base font-medium leading-5 text-left bg-gradient-to-r from-purple-600 to-blue-600 bg-clip-text text-transparent self-center"
                   >
                     Compare all plans →
                   </a>
                 </div>
               </div>         
            </div> */}

            {/* Right Column */}
            <div className="flex flex-col gap-3 lg:gap-6 justify-start items-center w-full lg:w-2/3">
              {loading ? (
                <div className="bg-white rounded-lg shadow p-8 flex justify-center items-center">
                  <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-violet-500"></div>
                </div>
              ) :error ? (
                <div className="bg-white rounded-lg shadow p-8">
                  <div className="flex items-center justify-center text-red-500">
                    <AlertCircle className="mr-2" size={20} />
                    <span>{error}</span>
                  </div>
                </div>
              ) : (
                <>
                  {/* Current Plan */}
                  <div className="flex flex-col gap-3 lg:gap-6 justify-start items-start w-full shadow-sm border border-gray-200 rounded-xl py-3 px-3 lg:py-6 lg:px-6 bg-white">
                    <span className="text-base lg:text-lg font-semibold leading-5 lg:leading-6 text-left text-black">Current Plan</span>

                    {billingData?.current_plan && billingData.current_plan.plan !== "free" ? (
                      <div className="flex flex-col gap-2 lg:gap-4 justify-start items-start w-full border border-gray-200 rounded-lg py-2 px-2 lg:py-4 lg:px-4 bg-white">
                        <div className="flex flex-col lg:flex-row lg:justify-between lg:items-start w-full gap-4">
                          <div className="flex-1 min-w-0">
                            <div className="flex items-center mb-2">
                              {(() => {
                                const planDetails = getPlanDetails(billingData.current_plan.plan);
                                return (
                                  <span className={`text-sm font-semibold px-2 py-1 rounded whitespace-nowrap ${planDetails.color}`}> 
                                    {planDetails.name} Plan                                 
                                  </span>
                                );
                              })()}
                            </div>
                            <div className="text-sm text-gray-600 mb-3">
                              <div className="flex items-start">
                                <Calendar size={14} className="mr-1 mt-0.5 flex-shrink-0" />
                                <span className="text-sm lg:text-base font-medium leading-5 text-left text-gray-800 break-words">
                                  Current period: {formatDate(billingData.current_plan.plan_start)} - {formatDate(billingData.current_plan.plan_end)}
                                </span>
                              </div>
                            </div>
                            <div className="pt-3 border-t border-gray-100">
                              <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
                                <div className="lg:col-span-1">
                                  <p className="text-sm lg:text-base font-medium leading-5 text-left text-gray-700">{billingData.current_plan.period.charAt(0).toUpperCase() + billingData.current_plan.period.slice(1)} Plan Limit</p>
                                  <p className="text-sm lg:text-base font-medium leading-5 text-left text-gray-800">{billingData.current_plan.limit || 'N/A'} image generations</p>
                                </div>
                                <div className="lg:col-span-1">
                                  <p className="text-sm lg:text-base font-medium leading-5 text-left text-gray-700">Next billing date</p>
                                  <p className="text-sm lg:text-base font-medium leading-5 text-left text-gray-800 break-words">{formatDate(billingData.current_plan.plan_end)}</p>
                                </div>
                                <div className="lg:col-span-1">
                                  <p className="text-sm lg:text-base font-medium leading-5 text-left text-gray-700">Status</p>
                                  <div className="flex items-center">
                                    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${
                                      billingData.current_plan.subscription_status === 'active' 
                                        ? 'bg-green-100 text-green-800' 
                                        : billingData.current_plan.subscription_status === 'canceled'
                                        ? 'bg-red-100 text-red-800'
                                        : 'bg-yellow-100 text-yellow-800'
                                    }`}>
                                      {billingData.current_plan.subscription_status ? 
                                        billingData.current_plan.subscription_status.charAt(0).toUpperCase() + 
                                        billingData.current_plan.subscription_status.slice(1) 
                                        : 'Unknown'}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="flex-shrink-0 lg:ml-4">
                            <button
                              onClick={handleBillingPortal}
                              disabled={portalLoading}
                              className={`px-3 py-2 lg:px-4 lg:py-2 text-sm font-medium rounded-md whitespace-nowrap flex items-center gap-2 ${
                                portalLoading
                                  ? "bg-gray-400 cursor-not-allowed text-gray-200"
                                  : "bg-blue-600 text-white hover:bg-blue-700 cursor-pointer"
                              }`}
                            >
                              {portalLoading && (
                                <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-current"></div>
                              )}
                              {portalLoading ? "Loading..." : "Manage Your Plan & Billing"}
                            </button>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <div className="flex flex-col gap-2 lg:gap-4 justify-start items-start w-full border border-gray-200 rounded-lg py-2 px-2 lg:py-4 lg:px-4 bg-white">
                        <div className="flex justify-between items-center">
                          <div className="flex flex-col gap-1 lg:gap-2 justify-start items-start">
                            <div className="flex items-center">
                              <span className="text-sm font-semibold px-2 py-1 rounded bg-gray-100 text-gray-800">
                                Free Plan
                              </span>
                            </div>
                            <div className="flex flex-row justify-start items-center w-full mt-2 text-sm text-gray-600">
                              <div className="flex flex-row justify-start items-center w-full">
                                <Calendar size={14} className="mr-1" />
                                <span className="mr-10">
                                  You're currently on the Free plan
                                </span>
                              </div>
                            </div>
                          </div>
                          <a
                            href="/pricing"
                            className="items-end px-4 py-2 bg-violet-50 text-violet-600 hover:bg-violet-100 text-sm font-medium rounded-md"
                          >
                            {billingData.current_plan.plan === "growth" ? "Downgrade Plan" : "Upgrade Plan"}
                          </a>
                        </div>
                      </div>
                    )}
                  </div>              

                </>)}

              {/* Billing History Section */}
              {/* <div className="flex flex-col gap-3 lg:gap-6 justify-start items-start w-full shadow-sm border border-gray-200 rounded-xl py-3 px-3 lg:py-6 lg:px-6 bg-white">
                <span className="text-base lg:text-lg font-semibold leading-5 lg:leading-6 text-left text-black">Billing History</span>
                <button 
                  className="cursor-pointer flex items-center text-sm text-gray-600 hover:text-violet-600"
                  onClick={refreshBillingData}
                >
                  <RefreshCw size={14} className="mr-1" />
                  <span>Refresh</span>
                </button> */}
                {/* Table */}
                {/* {billingData?.billing_history && billingData.billing_history.length > 0 ? (
                <div className="w-full border border-gray-200 rounded-xl overflow-auto max-h-96">
                  <div className="min-w-[700px]"> */}
                    {/* Table Header */}
                    {/* <div className="flex flex-row items-center w-full bg-slate-50">
                      <div className="flex flex-col justify-start items-center min-w-[160px] max-w-[520px] flex-1 py-1.5 px-2 border-b border-gray-200">
                        <span className="text-xs font-semibold leading-4 text-left text-gray-700">TRANSACTION ID</span>
                      </div>
                      <div className="flex flex-col justify-start items-center min-w-[80px] max-w-[100px] flex-1 py-1.5 px-2 border-b border-gray-200">
                        <span className="text-xs font-semibold leading-4 text-left text-gray-700">INVOICE</span>
                      </div>
                      <div className="flex flex-col justify-start items-center min-w-[60px] max-w-[80px] flex-1 py-1.5 px-2 border-b border-gray-200">
                        <span className="text-xs font-semibold leading-4 text-left text-gray-700">AMOUNT</span>
                      </div>
                      <div className="flex flex-col justify-start items-center min-w-[100px] max-w-[150px] flex-1 py-1.5 px-2 border-b border-gray-200">
                        <span className="text-xs font-semibold leading-4 text-left text-gray-700">STATUS</span>
                      </div>
                      <div className="flex flex-col justify-start items-center min-w-[80px] max-w-[120px] flex-1 py-1.5 px-2 border-b border-gray-200">
                        <span className="text-xs font-semibold leading-4 text-left text-gray-700">ACTION</span>
                      </div>
                    </div> */}

                    {/* Table Rows */}
                    {/* {billingData?.billing_history?.map((row, index) => (
                      <div key={index} className="flex flex-row items-center w-full">
                        <div className="flex flex-row justify-start items-center min-w-[160px] max-w-[520px] flex-1 py-3 px-2 border-b border-gray-200 overflow-x-auto">
                          <span className="text-sm font-normal leading-5 text-left text-gray-800 break-all">{row?.transaction_id}</span>
                        </div>
                        <div className="flex flex-row justify-start items-center min-w-[80px] max-w-[100px] flex-1 py-3 px-2 border-b border-gray-200 overflow-x-auto">
                          <span className="text-sm font-normal leading-5 text-left text-gray-800 break-all">{row?.invoice_number}</span>
                        </div>
                        <div className="flex flex-row justify-start items-center min-w-[60px] max-w-[80px] flex-1 py-3 px-2 border-b border-gray-200 overflow-x-auto">
                          <span className="text-sm font-normal leading-5 text-center text-gray-800 break-all">{row?.amount} {row?.currency}</span>
                        </div>
                        <div className="flex flex-row justify-center items-center min-w-[100px] max-w-[150px] flex-1 py-3 px-2 border-b border-gray-200 overflow-x-auto">
                          <div className="flex flex-row justify-center items-center w-auto bg-green-100 rounded-2xl">
                            <span className="text-sm font-normal leading-5 text-left text-green-700 break-all">{row?.status}</span>
                          </div>
                        </div>
                        <div className="flex flex-row justify-center items-center min-w-[80px] max-w-[120px] flex-1 py-3 px-2 border-b border-gray-200 overflow-x-auto">
                          <img src="/images/img_arrow_down.svg" alt="action" className="w-5 h-5" />
                        </div>
                      </div>
                    ))}
                  </div>
                </div>) : (
                  <div className="text-center py-8 text-gray-500">
                    No billing history available
                  </div>
                    )}
              </div> */}
            </div>
          </div>
        </div>
      </div>
    </div>
    </>
  );
};